import { Component, OnInit } from '@angular/core';
import { GungAppComponent } from 'gung-standard';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'car-liner-app-wrapper',
    templateUrl: './car-liner-app-wrapper.component.html',
    styleUrls: ['./car-liner-app-wrapper.component.scss'],
    standalone: false
})
export class CarLinerAppWrapperComponent extends GungAppComponent implements OnInit {
  public isThailand: boolean = environment.projectName === 'thailand';
  public isProduction: boolean = environment.production;
  denyAccess: boolean = false;
  suggestedRedirectDomains: string[] = [];

  ngOnInit(): void {
    super.ngOnInit();

    if (!this.isThailand && this.isProduction && window.location.hostname !== 'localhost') {
      const domainGroupMap = new Map<string, string>([
        ['car-o-liner.se', '12COL'],
        ['josam.se', '12JOSAM'],
        ['blackhawkcollision.com', '12BLACKHAWK']
      ]);

      const currentHostname = window.location.hostname.toLowerCase();
      const baseDomain = currentHostname
        .replace(/^sales-test\./, '')
        .replace(/^sales\./, '')
      const requiredGroup = domainGroupMap.get(baseDomain);

      this.authService.getUserActiveGroups().subscribe(groupMap => {
        if (requiredGroup && groupMap[requiredGroup] === true) {
          // User is allowed to stay
          // No redirect needed — continue with the rest of the component
          this.denyAccess = false;
        } else {
          const redirectDomains = [...domainGroupMap.entries()]
            .filter(([_, group]) => groupMap[group] === true)
            .map(([domain, _]) => domain);
          if (redirectDomains.length !== 0 && !redirectDomains.includes(baseDomain)) {
            const protocol = window.location.protocol;

            const isTestEnvironment = currentHostname.startsWith('sales-test.');
            const subdomain = isTestEnvironment ? 'sales-test' : 'sales';

            this.suggestedRedirectDomains =
              redirectDomains.map(redirectDomain => `${protocol}//${subdomain}.${redirectDomain}`);
            this.denyAccess = true;
          }
        }
      });
    }
  }
}
